<template>
	<div id="test">
		<vue-snotify></vue-snotify>
		<nav>
			<div class="nav nav-tabs" id="nav-tab" role="tablist">
				<a class="nav-item nav-link" id="nav-test1-tab" data-toggle="tab" href="#nav-test1" role="tab" aria-controls="nav-test1" aria-selected="true">Token Assinet</a>
				<a class="nav-item nav-link" id="nav-test2-tab" data-toggle="tab" href="#nav-test2" role="tab" aria-controls="nav-test2" aria-selected="false">OFs Starken</a>
				<a class="nav-item nav-link" id="nav-test3-tab" data-toggle="tab" href="#nav-test3" role="tab" aria-controls="nav-test3" aria-selected="false">Suscripciones</a>
				<a class="nav-item nav-link" id="nav-test4-tab" data-toggle="tab" href="#nav-test4" role="tab" aria-controls="nav-test4" aria-selected="false">Botones & Input</a>
				<a class="nav-item nav-link" id="nav-test5-tab" data-toggle="tab" href="#nav-test5" role="tab" aria-controls="nav-test5" aria-selected="false">Products WEB</a>
				<a class="nav-item nav-link active" id="nav-test6-tab" data-toggle="tab" href="#nav-test6" role="tab" aria-controls="nav-test6" aria-selected="false">Asistente</a>
			</div>
		</nav>
		<div class="tab-content" id="nav-tabContent">
			<div class="tab-pane fade container" id="nav-test1" role="tabpanel" aria-labelledby="nav-test1-tab">
				<div class="form-row">
					<div class="form-group col-md-4">
						<input type="text" class="form-control form-control-sm" id="inputToken" v-model="token" disabled="true" :placeholder="(gettingToken) ? 'Obteniendo Token ...' : 'Token'">
					</div>
					<div class="form-group col-md-2">
						<button type="submit" class="btn btn-sm btn-primary" disabled="true" v-if="gettingToken"><i class="fas fa-spinner fa-spin"></i></button>
						<button type="submit" class="btn btn-sm btn-primary" @click="getTokenAssinet" v-else>Obtener Token</button>
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-md-4">
						<select class="form-control form-control-sm" v-model="listComponentsSelected">
							<option v-for="(item, index) in listComponents" :key="index" :value="index">{{ item.name }}</option>
						</select>
					</div>
					<div class="form-group col-md-2">
						<button type="submit" class="btn btn-sm btn-primary" @click="payloadService(listComponentsSelected)" :disabled="token == ''" ref="executeComponent">Ejecutar</button>
					</div>
				</div>
				<table v-if="xmlResult != null" class="table table-sm table-12 table-striped">
					<tbody>
						<tr v-for="(item, index) in xmlResult.AASIS.Result.ChartOfAccountsResult.ArrayOfAccount.Account" :key="index">
							<td @dblclick="viewAllItem(item)">{{item.Code._text}}</td>
							<td>{{item.Name._text}}</td>
							<td>{{item.ParentCode._text}}</td>
							<td>
								<div v-if="item.Restrictions.BaseEntity.length > 0">
									<div v-for="(ite, inde) in item.Restrictions.BaseEntity" :key="inde">
										{{ite.Code._text}} - {{ite.Name._text}}
									</div>
								</div>
								<div v-else>
									{{item.Restrictions.BaseEntity.Code._text}} - {{item.Restrictions.BaseEntity.Name._text}}
								</div>
							</td>
							<td>{{item.SubAccountType.Code._text}}</td>
						</tr>
					</tbody>
				</table>
				<pre>
					{{ xmlResult }}
				</pre>
			</div>
			<div class="tab-pane fade container" id="nav-test2" role="tabpanel" aria-labelledby="nav-test2-tab">
				<textarea class="form-control form-control-sm" v-model="ofStarkens"></textarea>
				<button class="btn btn-primary btn-sm" @click="sanitizeOfStarkens">Buscar</button>
				<input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="entregado">
				<table class="table table-sm table-striped table-hover">
					<tbody>
						<tr v-for="(item, index) in listOfStarken" :key="index" @click="jsonResult = item" v-if=" item.status != 'ENTREGADO' || entregado">
							<td>{{ item.of }}</td>
							<td>{{ item.created_at | dateZ }}</td>
							<td>{{ item.updated_at | dateZ }}</td>
							<td>{{ item.destination }}</td>
							<td>{{ item.receiver_name }}</td>
							<td>{{ item.status }}</td>
							<td>{{ item.status_op }}</td>
						</tr>
					</tbody>
				</table>
				<pre>
					{{ jsonResult }}
				</pre>
			</div>
			<div class="tab-pane fade container" id="nav-test3" role="tabpanel" aria-labelledby="nav-test3-tab">
				<nav class="navbar navbar-light bg-light">
					<div class="form-inline">
						<input class="form-control form-control-sm mr-sm-1" type="date" v-model="fromDateGenesys">
						<input class="form-control form-control-sm mr-sm-1" type="date" v-model="toDateGenesys">
						<input class="form-control form-control-sm mr-sm-2" type="search" placeholder="Buscar" aria-label="Buscar" v-model="searchMovimiento" v-on:keyup.enter="searchSuscripcion">
						<button class="btn btn-sm btn-outline-success my-2 my-sm-0" type="button" @click="searchSuscripcion">Buscar</button>
					</div>
					<div class="form-inline">
						<div class="form-check">
							<input type="checkbox" class="form-check-input" id="viewOnlyWarning" v-model="viewOnlyWarning">
							<label class="form-check-label" for="viewOnlyWarning">Solo Extraños</label>
						</div>
					</div>
				</nav>
				<table class="table table-sm table-striped table-hover">
					<thead>
						<tr>
							<th>Campo</th>
							<th>Cliente</th>
							<th>CPIL</th>
							<th>Dirección</th>
							<th>Telefono</th>
							<th>Transporte</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in listEnvioSuscripcion" :key="index" v-show="!viewOnlyWarning || (viewOnlyWarning && (index > 0 && listEnvioSuscripcion[index-1].clicodcli == item.clicodcli) || (index < listEnvioSuscripcion.length-1 && listEnvioSuscripcion[index+1].clicodcli == item.clicodcli))">
							<td :title="item.campomiscod">{{ item.campomisdesc }}</td>
							<td :title="item.clicodcli">{{ item.cliente }}</td>
							<td :title="item.clicodcpil">{{ item.cpil }}</td>
							<td :title="item.domicod">{{ item.direccion + ' (' + item.dptodesc + ')' }}</td>
							<td>{{ item.domitel }}</td>
							<td>{{ item.trandesc }}</td>
							<td>
								<i v-if="(index > 0 && listEnvioSuscripcion[index-1].clicodcli == item.clicodcli) || (index < listEnvioSuscripcion.length-1 && listEnvioSuscripcion[index+1].clicodcli == item.clicodcli)"
									class="fa fa-exclamation-triangle text-warning" aria-hidden="true"></i>
								<i class="fa fa-eye pointer text-info" aria-hidden="true" @click="searchSuscripcionByValues(item)"></i>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="modal fade" id="showModalListEnvioSuscripcionDetail" tabindex="-1" aria-labelledby="showModalListEnvioSuscripcionDetail" aria-hidden="true">
					<div class="modal-dialog modal-lg">
						<div class="modal-content">
							<div class="modal-header">
								<h5 class="modal-title" id="showModalListEnvioSuscripcionDetail">Movimientos {{ itemSelectListEnvioSuscripcion.cliente }} ({{ itemSelectListEnvioSuscripcion.campomisdesc}})</h5>
								<button type="button" class="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div class="modal-body">
								<div>
									<div class="form-group row">
										<label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">Enviar a:</label>
										<div class="col-sm-10">
											<select v-model="itemSelectListEnvioSuscripcion.clicodcpil" class="form-control form-control-sm" @change="getDomicilioIdCliente(itemSelectListEnvioSuscripcion.clicodcpil)">
												<option v-for="(item, index) in listVinculoCli" :key="index" :value="item.vinclicod" v-if="item.vigente == '1' && item.tipovincod == '1'">{{ item.vincliente }}</option>
											</select>
											<small id="emailHelp" class="form-text text-muted">{{ itemSelectListEnvioSuscripcion.cpil }}</small>
										</div>
									</div>									
									<div class="form-group row">
										<label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">Direccion:</label>
										<div class="col-sm-10">
											<select v-model="itemSelectListEnvioSuscripcion.domicod" class="form-control form-control-sm" @change="setValueComuna()">
												<option v-for="(item, index) in listDomicilioCliente" :key="index" :value="item.domicod">{{ item.domicalle }}</option>
											</select>
											<small id="emailHelp" class="form-text text-muted">{{ itemSelectListEnvioSuscripcion.direccion }}</small>
										</div>
									</div>									
									<div class="form-group row">
										<label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">Comuna:</label>
										<div class="col-sm-4">
											<input type="comuna" class="form-control form-control-sm" id="colFormLabelSm" placeholder="col-form-label-sm" v-model="itemSelectListEnvioSuscripcion.dptodesc" disabled="true">
										</div>
										<label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">Telefono:</label>
										<div class="col-sm-4">
											<input type="telefono" class="form-control form-control-sm" id="colFormLabelSm" placeholder="col-form-label-sm"
												v-model="itemSelectListEnvioSuscripcion.domitel"
												@blur="itemSelectListEnvioSuscripcion.setDomitel = 'false'; itemSelectListEnvioSuscripcion.domitel = itemSelectListEnvioSuscripcion.domitel_back"
												@keyup.enter="changeDomitel()"
												@focus="itemSelectListEnvioSuscripcion.domitel_back = itemSelectListEnvioSuscripcion.domitel">
										</div>
									</div>
									<div class="form-group row">
										<label for="colFormLabelSm" class="col-sm-2 col-form-label col-form-label-sm">Transporte:</label>
										<div class="col-sm-4">
											<input type="transporte" class="form-control form-control-sm" id="colFormLabelSm" placeholder="col-form-label-sm"
												v-model="itemSelectListEnvioSuscripcion.trandesc"
												@blur="itemSelectListEnvioSuscripcion.setTrandesc = 'false'; itemSelectListEnvioSuscripcion.trandesc = itemSelectListEnvioSuscripcion.trandesc_back"
												@keyup.enter="changeTrandesc()"
												@focus="itemSelectListEnvioSuscripcion.trandesc_back = itemSelectListEnvioSuscripcion.trandesc">
										</div>
									</div>
								</div>
								<table class="table table-sm">
									<thead>
										<tr class="text-center">
											<th>Comprobante</th>
											<th>Nro Comp</th>
											<th>Fecha</th>
											<th>Usuario</th>
											<th>Lote</th>
										</tr>
									<thead>
									</thead>
										<tr v-for="(item, index) in listMovimientosEnvios" :key="index">
											<td>{{ item.tipocompdesc }}</td>
											<td class="text-right">{{ item.nrocomp }}</td>
											<td class="text-center">{{ item.feccomp }}</td>
											<td>{{ item.usuario }}</td>
											<td class="text-center">{{ item.lote }}</td>
										</tr>
									</thead>
								</table>
							</div>
							<div class="modal-footer">
								<button type="button" v-show="false" data-toggle="modal" data-target="#showModalListEnvioSuscripcionDetail" ref="showModalListEnvioSuscripcionDetail">Launch demo modal</button>
								<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">Cerrar</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="tab-pane fade container" id="nav-test4" role="tabpanel" aria-labelledby="nav-test4-tab">
				<input-auto-complete-componenet
						ref="inputAutoCompleteComponenetSendTo"
						placeholder="Escriba a quien se envía"
						_class="form-control form-control-sm"
						:urlGet="'client/19/sendto'"
						_id="inputSendToOrder"
						:text="dataTest4.text"
						:vmodel="dataTest4.id"
						:disabled="false"
						@actionSelectItem="setActionLocal"></input-auto-complete-componenet>
						<button class="btn btn-primary btn-sm" @click="claarAutoComplete">limpiar</button>
				<br/>
				<input-search-intelligent-component
					:minCharsAnalyze="1"
					:analyzeAuto="true"
					_class="form-control form-control-sm"
					@actionKeyUp="actionKeyUpLocal"
					@actionKeyEnter="actionKeyEnterLocal">
				</input-search-intelligent-component>
				<div>
					<div class="row">
						<div class="col-3">Imagen</div>
						<div class="col-9">Titulo</div>
					</div>
					<div>
						<select class="form-control form-control-sm">
							<option value="0">Seleccione el Modulo</option>
						</select>
					</div>
					<div>
						<input type="number" read-only class="form-control mt-1">
					</div>
					<numeric-keyboard-component @clickDigit="clickDigitLocal" extra1="Limpiar" class_extra1="digit-small-small" extra2="Borrar" class_extra2="digit-small-small"></numeric-keyboard-component>
				</div>
			</div>
			<div class="tab-pane fade container" id="nav-test5" role="tabpanel" aria-labelledby="nav-test5-tab">
				<span @click="getAllJumpsellerProducts">{{listJumpsellerProducts.length}}</span>
				<table class="table table-sm table-hover">
					<tbody>
						<tr v-for="(item, index) in listJumpsellerProducts" :key="index">
							<td>{{item.product.sku}}</td>
							<td>{{item.product.barcode}}</td>
							<td>
								<span v-if="item.product.images.length > 0">{{item.product.images[0].url}}</span>
							</td>
						</tr>
					</tbody>
				</table>
				<pre>
					{{listJumpsellerProducts}}
				</pre>
			</div>
			<div class="tab-pane fade container show active" id="nav-test6" role="tabpanel" aria-labelledby="nav-test6-tab">
			</div>
		</div>
	</div>

</template>

<script>
import { mapState, mapMutations } from 'vuex';

import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import assinet from '@/mixins/accountancy/assinet.js'
import genesys from '@/mixins/genesys'
import suscripcion from '@/mixins/genesys/suscripcion.js'
import cliente from '@/mixins/genesys/cliente.js'
import domicilio from '@/mixins/genesys/domicilio.js'
import jumpseller from '@/mixins/jumpseller'

import InputAutoCompleteComponent from '@/components/InputAutoCompleteComponent.vue'

import InputSearchIntelligentComponent from '@/components/InputSearchIntelligentComponent.vue'
import NumericKeyboardComponent from '@/components/NumericKeyboardComponent.vue'

export default {
	name: 'Test',
	mixins: [mixin, errors, axiosAction, assinet, genesys, suscripcion, cliente, domicilio, jumpseller],
	data() {
		return {
			UserName: 'genesis.externalsystem',
			XmlContent: '',
			webServicesDSA: {
				restricciones: '<AASIS><Context><AccountingEntity>{{Entity}}</AccountingEntity><Certificate>{{Certificate}}</Certificate><Component><Name>ChartOfRestrictions</Name></Component><Parameters><ChartOfRestrictionsParams><AcceptEntries></AcceptEntries></ChartOfRestrictionsParams></Parameters></AASIS>',
				planDeCuenta: '<AASIS><Context><AccountingEntity>{{Entity}}</AccountingEntity><Certificate>{{Certificate}}</Certificate><Component><Name>ChartOfAccounts</Name></Component><Parameters/></AASIS>',
				planDeActual: '<AASIS><Context><AccountingEntity>{{Entity}}</AccountingEntity><Certificate>{{Certificate}}</Certificate><Component><Name>ChartOfAccountsCustom</Name></Component><Parameters><ChartOfAccountsCustomParams><AcceptEntries>true</AcceptEntries><Year>2020</Year></ChartOfAccountsCustomParams></Parameters></AASIS>',
				planDeCuentaAuxiliar: '<AASIS><Context><AccountingEntity>{{Entity}}</AccountingEntity><Certificate>{{Certificate}}</Certificate><Component><Name>ChartOfAccountsAuxiliary</Name></Component><Parameters/></AASIS>',
				fondos: '<AASIS><Context><AccountingEntity>{{Entity}}</AccountingEntity><Certificate>{{Certificate}}</Certificate><Component><Name>ChartOfFunds</Name></Component><Parameters><ChartOfFundsParams><AcceptEntries></AcceptEntries></ChartOfFundsParams></Parameters></AASIS>',
				departamentos: '<AASIS><Context><AccountingEntity>{{Entity}}</AccountingEntity><Certificate>{{Certificate}}</Certificate><Component><Name>ChartOfFunctions</Name></Component><Parameters><ChartOfFunctionsParams><IsStandard>true</IsStandard></ChartOfFunctionsParams></Parameters></AASIS>',
				subAccountSyncList: '<AASIS><Context><AccountingEntity>{{Entity}}</AccountingEntity><Certificate>{{Certificate}}</Certificate><Component><Name>SubAccountSyncList</Name></Component><Parameters><SubAccountsSyncListParams><UpdatedSince>2000-01-01</UpdatedSince></SubAccountsSyncListParams></Parameters></AASIS>',
			},
			xml: '',
			ofStarkens: '939991476, 940125480, 940125340',
			ofStarkensList: [],
			listOfStarken: [],
			jsonResult: null,
			urlStarken: 'https://gateway.starken.cl/tracking/orden-flete/of/',
			entregado: false,
			viewOnlyWarning: true,
			dataTest4: {
				id: 0,
				text: ''
			},
			text: '',
			message: ''
		}
	},
	methods: {
		...mapMutations(['setTitleModule', 'setSubTitleModule']),
		actionKeyUpLocal(result) {
		},
		actionKeyEnterLocal(result) {
		},
		clickDigitLocal(val) {
			console.log(val)
		},
		initModuleLocal() {
			this.setTitleModule('Modulo de Pruebas')
			this.setSubTitleModule('Assinet')
			this.fromDateGenesys = this.currentDate(-30)
			this.toDateGenesys = this.currentDate()
		},
		onDecode(result) {
			console.log('onDecode', result)
		},
		onError(result) {
			console.log('onError', result)
		},
		onLoaded(result) {
			console.log('onLoaded', result)
		},
		getEnvioSuscripcionByValuesResultLocal() {
			this.$refs.showModalListEnvioSuscripcionDetail.click()
			this.getVinculoCli(this.itemSelectListEnvioSuscripcion.clicodcli)
		},
		getVinculoCliResultLocal(response) {
			this.getDomicilioIdCliente(this.itemSelectListEnvioSuscripcion.clicodcpil)
		},
		getDomicilioIdClienteResultLocal(response) {
			this.itemSelectListEnvioSuscripcion.domicod
			let index = this.listDomicilioCliente.map((el) => el.domicod).indexOf(this.itemSelectListEnvioSuscripcion.domicod)
			if(index < 0 && this.listDomicilioCliente.length > 0) {
				this.itemSelectListEnvioSuscripcion.domicod = this.listDomicilioCliente[0].domicod
				this.setValueComuna()
			}
		},
		setValueComuna() {
			this.setDomicod(this.listMovimientosEnvios, this.itemSelectListEnvioSuscripcion.domicod, '1', this.itemSelectListEnvioSuscripcion.clicodcpil)
		},
		resultGetTokenModule() {
			setTimeout(() => { this.$refs.executeComponent.click() }, 10);
		},
		sanitizeOfStarkens() {
			this.ofStarkens = this.ofStarkens.replaceAll('\n', ',')
			let ofs = this.ofStarkens.split(',')
			this.ofStarkens = ''
			let ofsD = []
			ofs.forEach(element => {
				if(element.trim() != "") {
					ofsD.push(element)
					this.ofStarkens+= (this.ofStarkens != '') ? ',' + element : element
				}
			});
			if(ofsD.length > 0) {
				this.ofStarkensList = ofsD
				console.log('Iniciando consulta de OFs')
				this.forOfStarkensList()
				this.listOfStarken = []
			}
		},
		forOfStarkensList() {
			if(this.ofStarkensList.length > 0) {
				this.searchOFStarken(this.ofStarkensList[0])
			} else {
				console.log('proceso terminado')
			}
		},
		searchOFStarken(of) {
			let config = {
				method: 'get',
				url: 'https://gateway.starken.cl/tracking/orden-flete/of/' + of,
				headers: { }
			};

			this.axios(config)
				.then(response => {
					this.listOfStarken.push(response.data)
					this.ofStarkensList.splice(0,1)
					this.forOfStarkensList()
				})
				.catch(error => {
					console.log(error);
					this.ofStarkensList.splice(0,1)
					this.forOfStarkensList()
				});
		},
		changeDomitel() {
			if(this.itemSelectListEnvioSuscripcion.domitel != this.itemSelectListEnvioSuscripcion.domitel_back && this.itemSelectListEnvioSuscripcion.domitel.trim() != '') {
				this.setDomitel(this.itemSelectListEnvioSuscripcion.domicod, this.itemSelectListEnvioSuscripcion.domitel.trim())
			}
		},
		changeTrandesc() {
			let changeTrandescOriginal = '1'
			if(this.itemSelectListEnvioSuscripcion.trandesc != this.itemSelectListEnvioSuscripcion.trandesc_back && this.itemSelectListEnvioSuscripcion.trandesc.trim() != '') {
				this.setTrandesc(this.listMovimientosEnvios, this.itemSelectListEnvioSuscripcion.trandesc, changeTrandescOriginal)
			}
		},
		setDomicodResultLocal(response) {
			this.itemSelectListEnvioSuscripcion.trandesc_back = this.itemSelectListEnvioSuscripcion.trandesc
		},
		setDomitelResultLocal(response) {
			this.itemSelectListEnvioSuscripcion.domitel_back = this.itemSelectListEnvioSuscripcion.domitel
		},
		setTrandescResultLocal(response) {
			let index = this.listDomicilioCliente.map((el) => el.domicod).indexOf(this.itemSelectListEnvioSuscripcion.domicod)
			this.itemSelectListEnvioSuscripcion.dptodesc = this.listDomicilioCliente[index].dptodesc
			this.itemSelectListEnvioSuscripcion.domitel = this.listDomicilioCliente[index].domitel
		},
		setActionLocal(item) {
			console.log(item)
		},
		claarAutoComplete() {
			this.$refs.inputAutoCompleteComponenetSendTo.$refs.buttonClearInputComplete.click()
		},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'askResult': this.askResult(response); break;
				case 'getAllJumpsellerProductsResult': this.getAllJumpsellerProductsResult(response); break;
				case 'resultGetToken': this.resultGetToken(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
        },
	},
	computed: {
		...mapState(['auth', 'role', 'menuLeft'])
	},
	components: {
		'input-auto-complete-componenet': InputAutoCompleteComponent,
		'input-search-intelligent-component': InputSearchIntelligentComponent,
		'numeric-keyboard-component': NumericKeyboardComponent,
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style>

</style>